import { PhoneOutlined } from '@ant-design/icons';
import { Button } from '@g2u/ui-kit';
import { type ChatActionHandler } from './types';

export const CallCustomerAction: ChatActionHandler = {
  type: 'CALL_CUSTOMER',
  render: (payload, helpers) => {
    if (!payload?.phone) return null;
    return (
      <Button.$
        dataTestId="ai-action-call-customer"
        type={Button.Type.Primary}
        size={Button.Size.Small}
        icon={<PhoneOutlined />}
        onClick={() => helpers.onCallCustomer(payload.phone)}
      >
        Call Customer
      </Button.$>
    );
  },
};
